function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 161,
  height: 26,
  rx: 13,
  fill: "#F4F2FF"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_55237_50445)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.666 16.6667C139.666 16.2985 139.964 16 140.333 16H142.333C142.701 16 142.999 16.2985 142.999 16.6667C142.999 17.0349 142.701 17.3333 142.333 17.3333H140.999V18.6667C140.999 19.0349 140.701 19.3333 140.333 19.3333C139.964 19.3333 139.666 19.0349 139.666 18.6667V16.6667Z",
  fill: "#5F5DE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.667 16C150.035 16 150.333 16.2985 150.333 16.6667V18H151.667C152.035 18 152.333 18.2985 152.333 18.6667C152.333 19.0349 152.035 19.3333 151.667 19.3333H149.667C149.298 19.3333 149 19.0349 149 18.6667V16.6667C149 16.2985 149.298 16 149.667 16Z",
  fill: "#5F5DE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M151.667 6.66602C152.035 6.66602 152.333 6.96449 152.333 7.33268V9.33268C152.333 9.70087 152.035 9.99935 151.667 9.99935H149.667C149.298 9.99935 149 9.70087 149 9.33268C149 8.96449 149.298 8.66602 149.667 8.66602H151V7.33268C151 6.96449 151.298 6.66602 151.667 6.66602Z",
  fill: "#5F5DE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M139.666 7.33268C139.666 6.96449 139.964 6.66602 140.333 6.66602H142.333C142.701 6.66602 142.999 6.96449 142.999 7.33268V9.33268C142.999 9.70087 142.701 9.99935 142.333 9.99935C141.964 9.99935 141.666 9.70087 141.666 9.33268V7.99935H140.333C139.964 7.99935 139.666 7.70087 139.666 7.33268Z",
  fill: "#5F5DE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M142.889 7.06327C143.092 7.3706 143.007 7.78411 142.7 7.98688C141.071 9.06123 139.999 10.9051 139.999 12.9991C139.999 13.3056 140.022 13.6064 140.066 13.8999C140.121 14.264 139.87 14.6035 139.506 14.6583C139.142 14.7131 138.803 14.4623 138.748 14.0982C138.694 13.7393 138.666 13.3722 138.666 12.9991C138.666 10.4383 139.979 8.18456 141.966 6.87395C142.273 6.67118 142.686 6.75594 142.889 7.06327Z",
  fill: "#5F5DE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M140.063 16.1103C140.371 15.9075 140.784 15.9923 140.987 16.2996C142.061 17.928 143.905 19.0001 145.999 19.0001C146.306 19.0001 146.606 18.9771 146.9 18.933C147.264 18.8782 147.604 19.129 147.658 19.4931C147.713 19.8572 147.462 20.1967 147.098 20.2515C146.739 20.3055 146.372 20.3334 145.999 20.3334C143.438 20.3334 141.185 19.0203 139.874 17.0339C139.671 16.7266 139.756 16.313 140.063 16.1103Z",
  fill: "#5F5DE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M152.493 11.3395C152.857 11.2848 153.197 11.5355 153.251 11.8996C153.305 12.2585 153.333 12.6256 153.333 12.9988C153.333 15.5596 152.02 17.8133 150.034 19.1239C149.727 19.3267 149.313 19.2419 149.11 18.9346C148.908 18.6273 148.992 18.2138 149.3 18.011C150.928 16.9366 152 15.0928 152 12.9988C152 12.6922 151.977 12.3914 151.933 12.098C151.878 11.7339 152.129 11.3943 152.493 11.3395Z",
  fill: "#5F5DE8"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M145.999 6.99935C145.692 6.99935 145.391 7.02229 145.098 7.06643C144.734 7.1212 144.394 6.87044 144.34 6.50635C144.285 6.14225 144.536 5.8027 144.9 5.74793C145.259 5.69394 145.626 5.66602 145.999 5.66602C148.56 5.66602 150.813 6.97909 152.124 8.96554C152.327 9.27286 152.242 9.68638 151.935 9.88914C151.627 10.0919 151.214 10.0072 151.011 9.69983C149.937 8.07146 148.093 6.99935 145.999 6.99935Z",
  fill: "#5F5DE8"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_55237_50445"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(138 5)"
})));

var SvgCycleDescription = function SvgCycleDescription(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 26,
    viewBox: "0 0 161 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCycleDescription, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cycle-description.a5e4c639.svg";
export { ForwardRef as ReactComponent };